import { createContext, useContext } from 'react';

import type { TypeProductMenuCode } from '~/constants/product';

/**
 * [상품관리] 상품 모달에서 사용할 menuCode를 제공하는 Context
 * @description 페이지별로 다른 menuCode(SKU_REG, PROD_SKU)를 모달 하위 컴포넌트에 전달
 */
const ProductMenuCodeContext = createContext<TypeProductMenuCode | null>(null);

export const ProductMenuCodeProvider = ProductMenuCodeContext.Provider;

export const useProductMenuCode = (): TypeProductMenuCode => {
  const menuCode = useContext(ProductMenuCodeContext);
  if (!menuCode) {
    throw new Error('ProductMenuCodeProvider 내부에서 사용해야 합니다');
  }
  return menuCode;
};
